import * as React from 'react';
import { connect } from 'react-redux';
import { Translate } from '../../../shared/LanguageService';
import * as brokerListActions from '../actions/BrokerListActions';
import BrokerAgentList from './BrokerAgentList';
import { Button, FormControl, FormGroup, ControlLabel, Checkbox } from 'react-bootstrap';
import FormSelect from '../../../components/common/FormSelect';
import AgentModal from '../agent/AgentModal';
import IBrokerListAgent from './IBrokerListAgent';
import { assign } from '../../../shared/Assign';

class BrokerListPage extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            searchFilter: '',
            firmFilter: '',
            showRemoved: false,
            editId: -1,
            shouldShowModal: false,
            selectedAgent: {}
        };

        this.search = this.search.bind(this);
        this.filterByFirm = this.filterByFirm.bind(this);
        this.openCreateModal = this.openCreateModal.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.openEditModal = this.openEditModal.bind(this);
        this.deleteBrokerAgent = this.deleteBrokerAgent.bind(this);
        this.restoreBrokerAgent = this.restoreBrokerAgent.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
    }

    componentDidMount() {
        this.props.actions.listBrokerAgents();
    }

    render() {
        let brokerAgents: IBrokerListAgent[] = assign([], this.props.brokerAgents);

        if (this.state.searchFilter.length > 0) {
            let lowerCaseSearchFilter = this.state.searchFilter.toLowerCase();

            brokerAgents = brokerAgents.filter((agent: IBrokerListAgent) => {
                return (
                    agent.name.toLowerCase().indexOf(lowerCaseSearchFilter) > -1 ||
                    agent.parentFirmName.toLowerCase().indexOf(lowerCaseSearchFilter) > -1
                );
            });
        }

        let firmFilter = this.state.firmFilter;
        if (firmFilter) {
            brokerAgents = brokerAgents.filter((brokerAgent: any) => {
                return brokerAgent.parentFirmId.toString() === firmFilter;
            });
        }

        let showRemoved = this.state.showRemoved;
        if (!showRemoved && brokerAgents) {
            brokerAgents = brokerAgents.filter((agent: any) => {
                return !agent.isRemoved;
            });
        }

        return (
            <div>
                <h1>{Translate('brokers/list/page/title/brokers')}</h1>
                <div className="row">
                    <div className="col-md-3">
                        <FormGroup controlId="search_box">
                            <ControlLabel>
                                {Translate('brokers/list/input-label/search')}
                            </ControlLabel>
                            <FormControl
                                type="text"
                                name="search"
                                value={this.state.searchFilter ? this.state.searchFilter : ''}
                                onChange={this.search}
                            />
                        </FormGroup>
                    </div>
                    <div className="col-md-3">
                        <FormGroup controlId="search_filter">
                            <ControlLabel>
                                {Translate('brokers/list/select-label/filter')}
                            </ControlLabel>
                            <FormSelect
                                name="filter"
                                value={this.state.firmFilter}
                                onChange={this.filterByFirm}
                            >
                                <option value="-1">
                                    {Translate('brokers/list/select-label/filter')}
                                </option>
                                {this.props.availableFirms &&
                                    this.props.availableFirms.map((t: any) => {
                                        return (
                                            <option key={t.id} value={t.id}>
                                                {t.name}
                                            </option>
                                        );
                                    })}
                            </FormSelect>
                        </FormGroup>
                    </div>
                    <div className="col-md-3 no-label">
                        <FormGroup>
                            <Checkbox
                                className=""
                                name="showRemoved"
                                checked={this.state.showRemoved}
                                onChange={this.onCheckboxChange}
                            >
                                <span>
                                    {Translate('brokers/list/checkbox-label/include-removed')}
                                </span>
                            </Checkbox>
                        </FormGroup>
                    </div>
                    <div className="col-md-3 no-label">
                        <Button
                            className="pull-right"
                            onClick={this.openCreateModal}
                            bsSize="large"
                            bsStyle="success"
                        >
                            {Translate('brokers/list/button-label/add-broker')}
                        </Button>
                    </div>
                </div>
                <BrokerAgentList
                    items={brokerAgents}
                    delete={this.deleteBrokerAgent}
                    restore={this.restoreBrokerAgent}
                    edit={this.openEditModal}
                    currentUserId={this.props.user.details.id}
                />

                {this.state.shouldShowModal && (
                    <AgentModal
                        onClose={this.toggleModal}
                        item={this.state.selectedAgent}
                        allowedListFirms={this.props.availableFirms}
                        isFromList={true}
                        allowedSites={this.props.allowedSites}
                    />
                )}
            </div>
        );
    }

    openCreateModal(): void {
        let selectedAgent: IBrokerListAgent = {
            id: 0,
            parentId: 0
        };
        this.setState({ selectedAgent: selectedAgent });
        this.toggleModal();
    }

    openEditModal(agent: IBrokerListAgent): void {
        agent.id = agent.nodeId;
        this.setState({ selectedAgent: agent });
        this.toggleModal();
    }

    deleteBrokerAgent(id: number) {
        this.props.actions.deleteListBrokerAgent(id);
    }

    restoreBrokerAgent(id: number) {
        this.props.actions.restoreListBrokerAgent(id);
    }

    toggleModal(): void {
        this.setState({ shouldShowModal: !this.state.shouldShowModal });
    }

    search(e: any) {
        return this.setState({ searchFilter: e.target.value });
    }

    filterByFirm(e: any) {
        if (e.target.value === '-1') {
            return this.setState({ firmFilter: '' });
        }

        return this.setState({ firmFilter: e.target.value });
    }

    onCheckboxChange(e: any) {
        this.setState({ showRemoved: !this.state.showRemoved });
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        brokerAgents: state.brokers.tableList.list,
        availableFirms: state.brokers.tableList.availableFirms,
        user: state.user,
        allowedSites: state.brokers.tableList.allowedSites
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            listBrokerAgents: () => dispatch(brokerListActions.list()),
            deleteListBrokerAgent: (id: number) =>
                dispatch(brokerListActions.deleteBrokerListAgent(id)),
            restoreListBrokerAgent: (id: number) =>
                dispatch(brokerListActions.restoreBrokerListAgent(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BrokerListPage);
